import React, { useEffect, useRef, useMemo, useState } from 'react';

import { StepsNavigationLegacy } from '@/widgets/ServiceFormTemplate';

import { ConditionView } from '@/shared/ui';

import { ServiceFeedback } from '@/components/Forms/ServiceFeedback';

import { SERVICE_CODES } from '@/lib/consts';

import { HeaderWithHomeLinkButton } from '../../../../../components/Forms/HeaderWithHomeLinkButton';
import { ServiceInformer } from '../../../../../components/Forms/ServiceInformer';
import { ServiceInformerContainer } from '../../../../../components/Forms/ServiceInformer/ServiceInformerContainer';
import { ServiceInformerType } from '../../../../../components/Forms/ServiceInformer/types';
import { ServiceNames, StepsNavigationName } from '../../../../../config/services';
import { stepsNavigationDataFactory } from '../../../../../helpers/stepsNavigationDataFactory';

import FormSteps from './Steps/StepInitial';

import './CancellationTemporaryResidenceRelocation.scss';
import '../../../../../containers/StyleSettings/themes/default/layout.scss';

const StepsNavigationData = stepsNavigationDataFactory([
  StepsNavigationName.permissionData,
  StepsNavigationName.signUp,
  StepsNavigationName.result,
]);

export const currentServiceCode = SERVICE_CODES.CANCELLATION_TEMPORARY_RESIDENCE_RELOCATION;
export const serviceName: string = ServiceNames[currentServiceCode];
export const totalSteps = StepsNavigationData.length;
export const stepNumberToSubmitForm = StepsNavigationData.length - 1;

export const CancellationTemporaryResidenceRelocation: React.FC = () => {
  const htmlRef = useRef<HTMLElement>(null);
  const [myObjects, setMyObjects] = useState(StepsNavigationData);
  const [currentRequestId, setCurrentRequestId] = useState<string>('');
  const currentStep = useMemo(() => myObjects.find((step) => step.active), [myObjects]);
  const isQrCodeInformerActive = useMemo(() => currentStep?.step === 2, [currentStep]);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const stepToActivate = Number(htmlRef.current?.querySelector('div[data-step]')?.getAttribute('data-step'));
      const newData = JSON.parse(JSON.stringify(myObjects)).map((step: (typeof StepsNavigationData)[0]) => {
        if (step.step === stepToActivate) {
          step.active = true;
          step.completed = false;
        } else {
          if (step.step < stepToActivate) {
            step.completed = true;
          }
          if (step.active) {
            step.active = false;
          }
        }

        return step;
      });

      setMyObjects(newData);
    });
    htmlRef.current && observer.observe(htmlRef.current, { childList: true, subtree: true });
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleReceiveRequestId = (requestId: string): void => {
    setCurrentRequestId(requestId);
  };

  return (
    <section className="section-block-medium section-light">
      <div className="container container-with-aside_margin-bottom-sm">
        <HeaderWithHomeLinkButton header={serviceName} />
      </div>
      <div className="wpp-container container container-with-two-asides container-with-aside_gap-md">
        <aside className="container-with-aside__aside">
          <StepsNavigationLegacy navigationData={myObjects} />
        </aside>
        <div>
          <section
            className="container-with-aside__section container-with-aside__section_width-md max-width-md"
            ref={htmlRef}
          >
            <FormSteps onReceiveRequestId={handleReceiveRequestId} />
          </section>

          <ConditionView if={myObjects[2]?.active && !!currentRequestId}>
            <ServiceFeedback requestId={currentRequestId} />
          </ConditionView>
        </div>
        <ServiceInformerContainer>
          {isQrCodeInformerActive && <ServiceInformer type={ServiceInformerType.QR_CODE1} />}
          <ServiceInformer type={ServiceInformerType.CONTACT_CENTER} />
        </ServiceInformerContainer>
      </div>
    </section>
  );
};
